import { Paper } from '@gto/ui/paper'

import type { Deal } from '@/api/gen'

import { DealCardContent } from './deal-card-content'
import { DealCardHeader } from './deal-card-header'

export type DealCardProps = Deal & { withSignUp?: boolean }
export const DealCard = (props: DealCardProps) => {
  const { deal_name, network, poker_site_local_s3_url } = props

  return (
    <Paper
      as="article"
      className="deal-card group flex size-full flex-col justify-between overflow-hidden rounded-md"
      elevation="3"
    >
      <DealCardHeader
        logo={poker_site_local_s3_url}
        name={deal_name}
        site={network}
      />
      <DealCardContent {...props} />
    </Paper>
  )
}
